import { ReducersInterfaceAction } from "types/Reducers";
import { DrawerConstants } from "../constants/constants";
import { DrawerState } from "../types/Drawer";
import { initialDrawerState } from "store/initialStates";

export const drawerReducer = (
  state = initialDrawerState,
  action: ReducersInterfaceAction,
): DrawerState => {
  switch (action.type) {
    case DrawerConstants.OPEN_DRAWER:
      return {
        ...state,
        isOpen: true,
        drawerName: action.payload,
      };
    case DrawerConstants.CLOSE_DRAWER:
      return {
        ...state,
        isOpen: false,
        drawerName: "",
      };
    default:
      return state;
  }
};
